export default "/images/developer-options-active-light.svg?fba5c205c964dbbb65cc115538453ec2";